module.exports = __webpack_public_path__ + "static/media/left-quote.f14b407c.svg";